export const ImageUtilities = {
  rotate: (image: HTMLImageElement, angle: number) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = angle % 180 === 0 ? image.width : image.height;
    canvas.height = angle % 180 === 0 ? image.height : image.width;

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((angle * Math.PI) / 180);
    ctx.drawImage(image, image.width / -2, image.height / -2);

    return canvas.toDataURL();
  },
  getDominantColor: (img: HTMLImageElement, sampleSize = 64) => {
    const canvas = document.createElement("canvas");
    canvas.width = sampleSize;
    canvas.height = sampleSize;

    const ctx = canvas.getContext("2d")!;
    ctx.drawImage(img, 0, 0, sampleSize, sampleSize);

    const { data } = ctx.getImageData(0, 0, sampleSize, sampleSize);

    let r = 0,
      g = 0,
      b = 0,
      count = 0;

    for (let i = 0; i < data.length; i += 4) {
      const alpha = data[i + 3];
      if (alpha < 128) continue; // skip transparent pixels

      r += data[i];
      g += data[i + 1];
      b += data[i + 2];
      count += 1;
    }

    if (count === 0) return "#000";

    r = Math.round(r / count);
    g = Math.round(g / count);
    b = Math.round(b / count);

    return "#" + [r, g, b].map(v => v.toString(16).padStart(2, "0")).join("");
  }
};
